<template>
    <div class="frame">
        <div class="frame-bg" @click="send(item,index)" :class="{active:index==selectIndex}" v-for="(item, index) in shareList" :key="index">
            <!-- {{ item }} -->
            <div :class="{size:item.length==4,size2:item.length>1}">
                {{ item }}
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'custom-frame',
    data() {
        return {
            selectIndex:0
        }
    },
    props: {
        shareList: {
            type: Array,
            default: () => {
                return ['A1', 'A2', 'B1-B2', 'B3', '公共区域']
            }
        }
    },
    methods:{
        send(item,index){
            this.selectIndex = index
            this.$emit('surplusData',item)
        }
    }
}
</script>

<style lang="scss" scoped>
.frame {
    display: flex;
    justify-content: center;
    color: #fff;
}

.frame-bg {
    width: 68px;
    height: 56px;
    background-image: url('../../assets/compImg/frame.png');
    background-size: cover;
    font-size: 24px;
    font-family: 'dina';
    margin-right: 9px;
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    cursor: pointer;
    pointer-events: all;
}
.frame-bg:last-child{
    margin-right: 0;
}
.size{
    font-size: 20px;
    width: 40px;
    height: 46px;
    line-height: 23px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.size2{
    font-size: 20px;
}
.frame-bg:nth-child(2){
    margin-right: 7px;
}
.active{
        background-image: url(../../assets/compImg/selectFrame.png);
    }
</style>